<ng-container [formGroup]="form">
  <ng-container formArrayName="charts">
    <!-- groups -->
    <ng-container *ngFor="let chartForm of chartArray.controls; first as isFirst; last as isLast; index as i; trackBy: trackBy">
      <div class="c-form--d c-form__section d-flex">
        <span class="c-line__label mr-10">
          {{ localizations.get(chartForm.value.title) ?? chartForm.value.title }}
        </span>
        <button p500-ui-confluent-button color="warn" size="small" type="button" (click)="removeForm(i)" i18n="@@common.remove">
          Remove
        </button>
        <div class="swap__btns__wrapper">
          <button (click)="swap(chartArray, i, i - 1)" [hidden]="isFirst" type="button" class="swap__btn">
            <p500-ui-icon name="arrows-select-up"></p500-ui-icon>
          </button>
          <button (click)="swap(chartArray, i, i + 1)" [hidden]="isLast" type="button" class="swap__btn">
            <p500-ui-icon name="arrows-select-down"></p500-ui-icon>
          </button>
        </div>
      </div>
      <div class="group c-form--d c-form__section">
        <ng-container [formGroup]="chartForm">
          <div class="c-form__section">
            <p500-ui-text-field formControlName="title" i18n-label="@@common.tab_title" label="Tab Title"></p500-ui-text-field>
          </div>
          <div class="row">
            <div class="c-form__section col-sm-6">
              <p500-ui-select-field formControlName="format" [data]="chartFormats" i18n-label="@@common.format" label="Format">
              </p500-ui-select-field>
            </div>
            <div class="c-form__section col-sm-6">
              <p500-ui-select-field
                formControlName="dateCompareKey"
                [data]="datesCompare"
                i18n-label="@@common.date_compare"
                label="Date Compare"
                [clearable]="true"
              >
              </p500-ui-select-field>
            </div>
          </div>
          <div class="row">
            <div class="c-form__section col-sm-6">
              <p500-ui-text-field formControlName="yAxisLabel" i18n-label="@@common.y_axis_label" label="Y-axis Label"></p500-ui-text-field>
            </div>
            <div class="c-form__section col-sm-6">
              <p500-ui-select-field
                formControlName="yAxisFormat"
                [data]="yAxisFormats"
                i18n-label="@@common.y_axis_format"
                label="Y-axis Format"
              >
              </p500-ui-select-field>
            </div>
          </div>
          <div class="row c-form--d c-form__section">
            <span class="fw-bold ml-5 mr-5" i18n="@@common.add_metrics">Add Metrics</span>
            <button p500-ui-circled-button size="small" color="primary" type="button" (click)="pushTermsForm(i)">
              <p500-ui-icon name="controls-plus"></p500-ui-icon>
            </button>
          </div>
          <ng-container formArrayName="terms">
            <ng-container
              *ngFor="
                let termsForm of chartForm.controls.terms.controls;
                first as isFirstTerm;
                last as isLastTerm;
                index as k;
                count as termsLength
              "
            >
              <ng-container [formGroup]="termsForm">
                <div class="c-form__section">
                  <div class="d-flex">
                    <p500-ui-select-field formControlName="uuid" [data]="terms" bindLabel="label" bindValue="id" class="flex-1">
                      <ng-template p500UIFieldLabel>
                        <div class="d-flex">
                          <span class="p500-ui-form-field__label" i18n="@@common.metric">Metric</span>
                          <div class="swap__btns__wrapper">
                            <button
                              (click)="swap(chartForm.controls.terms, k, k - 1)"
                              [hidden]="isFirstTerm"
                              type="button"
                              class="swap__btn"
                            >
                              <p500-ui-icon name="arrows-select-up"></p500-ui-icon>
                            </button>
                            <button
                              (click)="swap(chartForm.controls.terms, k, k + 1)"
                              [hidden]="isLastTerm"
                              type="button"
                              class="swap__btn"
                            >
                              <p500-ui-icon name="arrows-select-down"></p500-ui-icon>
                            </button>
                          </div>
                        </div>
                      </ng-template>
                    </p500-ui-select-field>
                    <button
                      p500-ui-circled-button
                      size="small"
                      type="button"
                      color="warn"
                      class="ml-10 mb-6 align-self-end"
                      [transparent]="true"
                      (click)="removeTermsForm(i, k)"
                      [hidden]="termsLength <= 1"
                    >
                      <p500-ui-icon name="controls-close"></p500-ui-icon>
                    </button>
                  </div>
                </div>
                <div class="c-form__section">
                  <p500-ui-color-select-field
                    formControlName="color"
                    i18n-label="@@common.color"
                    label="Color"
                  ></p500-ui-color-select-field>
                </div>
                <div class="c-form__section">
                  <p500-ui-color-select-field
                    formControlName="secondaryColor"
                    i18n-label="@@common.comparison_color"
                    label="Comparison Color"
                  >
                  </p500-ui-color-select-field>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <!-- groups -->
  </ng-container>

  <div class="c-form__section c-form--d c-form__section" [hidden]="!form.controls.charts.length">
    <p500-ui-select-field [data]="chartIds" formControlName="defaultId" i18n-label="@@common.default_tab" label="Default Tab">
    </p500-ui-select-field>
  </div>

  <div class="row">
    <div class="c-line__label ml-5 mr-5" i18n="@@common.add_tab">Add Tab</div>
    <button p500-ui-circled-button size="small" color="primary" type="button" (click)="pushFullForm()">
      <p500-ui-icon name="controls-plus"></p500-ui-icon>
    </button>
  </div>
</ng-container>
